import React, { useEffect, useState } from "react";
import { Card, Table, Button, Row, Col, Form, Pagination } from '@themesberg/react-bootstrap';
import { useHistory } from "react-router-dom";
import api from "../../utils/api";

export default function UsersReportsList() {
  const history = useHistory();
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [search, setSearch] = useState("");

  /* const fetchData = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/reports`, { params: { page, perPage, search } });
      if (!data.error) {
        setItems(data.data);
        setTotal(data.total);
      }
    } finally {
      setLoading(false);
    }
  }; */

  const fetchData = async () => {
  setLoading(true);
  try {
    const { data } = await api.get(`/reports`, { 
      params: { 
        page, 
        pageSize: perPage,   // <-- FIXED
        search 
      } 
    });

    if (!data.error) {
      setItems(data.data);
      setTotal(data.total);
    }
  } finally {
    setLoading(false);
  }
};


  useEffect(() => { fetchData(); }, [page, perPage]);

  const totalPages = Math.ceil(total / perPage) || 1;

  const handleView = async (id) => {
    history.push(`/reports/${id}`);
  };

  return (
    <Card className="shadow-sm">
      <Card.Header>
        <Row className="align-items-center">
          <Col><h5 className="mb-0">Reported Profiles List</h5></Col>
        </Row>
        <Row className="mt-3">
          <Col md={6}>
            <Form.Control placeholder="Search..." value={search} onChange={(e)=>setSearch(e.target.value)} />
          </Col>
          <Col md={2}>
            <Button variant="outline-secondary" onClick={()=>{ setPage(1); fetchData(); }}>Search</Button>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <Table responsive hover className="align-items-center">
          <thead>
            <tr>
              <th>#</th>
              <th>Reporter</th>
              <th>Reporter Email</th>
              <th>Report Type (Group/User)</th>
              <th>Reported Name</th>
              <th>Reported Email</th>
              <th>Reason</th>
              {/* <th>Notes</th> */}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map((n, index) => (
              <tr key={n.id}>
                <td>{(page - 1) * perPage + index + 1}</td>
                <td>{n.reportedBy ? n.reportedBy.name || '-' : '-'}</td>
                <td>{n.reportedBy ? n.reportedBy.email || '-' : '-'}</td>
                <td><span className="badge bg-secondary">{n.entity_type === 'user' ? 'User' : 'Group'}</span></td>
                <td>{
                    n.entity_type === 'user' ? n.reportedUser.name || '-' : n.reportedGroup.name || '-'
                  }</td>
                <td>{n.reportedUser ? n.reportedUser.email || '-' : '-'}</td>
                <td>{n.reason || '-'}</td>
                {/* <td>{n.notes || '-'}</td> */}
                <td>
                  <Button size="sm" variant="outline-info" className="me-2" onClick={()=>handleView(n.id)}>View</Button>                 
                </td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr><td colSpan={8} className="text-center">{loading ? 'Loading...' : 'No data'}</td></tr>
            )}
          </tbody>
        </Table>
        <div className="d-flex justify-content-between align-items-center">
          <Form.Select style={{ maxWidth: 120 }} value={perPage} onChange={(e)=>{ setPerPage(parseInt(e.target.value,10)); setPage(1); }}>
            {[10,20,50].map(n=> <option key={n} value={n}>{n} / page</option>)}
          </Form.Select>
          <Pagination className="mb-0">
          
                      {/* Prev */}
                      <Pagination.Prev
                        disabled={page <= 1}
                        onClick={() => setPage((p) => Math.max(1, p - 1))}
                      />
          
                      {/* Page numbers: previous */}
                      {page > 1 && (
                        <Pagination.Item onClick={() => setPage(page - 1)}>
                          {page - 1}
                        </Pagination.Item>
                      )}
          
                      {/* Active page */}
                      <Pagination.Item active>{page}</Pagination.Item>
          
                      {/* Page numbers: next */}
                      {page < totalPages && (
                        <Pagination.Item onClick={() => setPage(page + 1)}>
                          {page + 1}
                        </Pagination.Item>
                      )}
          
                      {/* Next */}
                      <Pagination.Next
                        disabled={page >= totalPages}
                        onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                      />
          
                    </Pagination>
        </div>
      </Card.Body>
    </Card>
  );
}
